// Structured void reasons for op-channel delta flips.
import { formatPredicate, formatRestrictionFailureReason, formatRowNotLiveFailureReason } from "../rschema/format_predicate.js";
export function formatOpVoidDetail(detail) {
    switch (detail.kind) {
        case 'restriction':
            return formatRestrictionFailureReason(detail.table, {
                action: detail.action,
                rowId: detail.rowId,
                values: {},
            }, detail.rule);
        case 'row-not-live':
            return formatRowNotLiveFailureReason(detail.table, detail);
        case 'fk':
            return `FK column '${detail.column}' in table '${detail.table}' points to non-live row '${detail.targetRowId}' in '${detail.targetRef}'`;
        case 'observe-gate':
            return `canObserve predicate rejected observation of '${detail.binding}': ${formatPredicate(detail.rule)}`;
        case 'authorization-cycle':
            return 'authorization cycle (least-fixpoint deny)';
        case 'bundle':
            return `bundle write ${detail.index}: ${formatOpVoidDetail(detail.detail)}`;
    }
}
